
import { ProductCard } from '@/components/products/ProductCard'
import { useState } from 'react'
import { VariantPopup } from '../common/VariantPopup'
import useCartStore, { ICartItem } from '@/store/cartStore'
import useCommonStore from '@/store/commonStore'
import { toast } from '@/hooks/use-toast'
import { GTMAddToCartHandler, GTMRemoveFromCartHandler } from '@/lib/analytics'

interface IObj {
  [key: string]: any
}
interface Product {
  pdt_nm: string
  price: string
  currency: string
  spl_prc: string
  spl_prc_in_num: number
  disc: string
  disc_typ: string
  slug: string
  thumbnail: string
  rating: number
  total_sold: number
  pdt_id: string
  path: string
  max_order_quantity: number
  variants: IObj[]
  in_stk: boolean
}

export function ProductList({ products }: { products: Product[] }) {

  const [variants, setVariants] = useState<IObj[]>([])
  const [mxq, setMxq] = useState<number>(-1)
  const { updateCart } = useCartStore()
  const { isAuth } = useCommonStore()

  const cartHandler = async (item: ICartItem, mxq?: number,type?:string,spl_prc?:number,pdt_nm?:string) => {


    if (type === "increment") {
      GTMAddToCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",

          }]
      })
    }
    else if (type === "decrease") {
      GTMRemoveFromCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",
          }]
      });
    }
    const update = await updateCart(item, mxq ?? -1, isAuth);
    if (update?.status) {
      toast({ variant: "default", title: "Cart updated", description: update?.message||"" });
      // setModalOpen(false)
    } else {
      toast({ variant: "destructive", title: update?.message, description: update?.error });
    }
  };

  const handleAddToCart = (max_order_quantity:number,product?:ICartItem|null,list?: IObj[],type?:string,spl_prc?:number,pdt_nm?:string) => {
    if (list && list.length > 0) {
      setMxq(max_order_quantity)
      setVariants(list)
      setModalOpen(true)
      return
    } else if(product){
      cartHandler(product,max_order_quantity,type,spl_prc,pdt_nm)
    }
  }
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-10">
      {products.map((product) => (
        <ProductCard
          key={product.pdt_id ?? product.slug ?? product.path}
          product={product}
          variant="grid"
          onAddToCart={handleAddToCart}
        />
      ))}
        {
          modalOpen && variants?.length && (
            <VariantPopup open={modalOpen} onClose={() => {
              setVariants([])
              setMxq(-1)
              setModalOpen(false)
            }} variants={variants || []} mxq={mxq} handler={cartHandler} />
          )
        }
      </div>
    </>
  )
}